import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetClientUser } from '~/hooks';

type Args = {
  userId: number;
};

type IUseUserDetailProfile = (args: Args) => {
  state: {
    data: ReturnType<typeof useGetClientUser>['data'];
  };
};

/**
 * 利用者詳細プロフィールコンポーネントの状態管理を提供する
 */
export const useUserDetailProfile: IUseUserDetailProfile = ({ userId }) => {
  const { data } = useGetClientUser({
    threeLetterCode: getThreeLetterCode() || '',
    id: userId,
  });

  return {
    state: { data },
  };
};
